export default __webpack_public_path__ + "static/media/head04_ko_pc@2x.76ac86d8.png";